export default "__VITE_ASSET__CKADJ85n__"